module.exports = __webpack_public_path__ + "img/option-2-preview.ca39bcb8.png";